import React, { FunctionComponent, ReactNode} from 'react';
import { Card, Icon, Typography } from 'ui-components';

import useStyles from './BoxWithIcon.style';

const BoxWithIcon: FunctionComponent<{
  title: ReactNode,
  subtitle: ReactNode,
  icon: React.ReactElement;
}> = ({title, subtitle, icon}) => {

  const c = useStyles({});

  return (
    <Card className={c.root} hoverable >
      <div className={c.iconWrapper}>
        <Icon>{icon}</Icon>
      </div>
      <Typography variant="h2" component="h4" className={c.title} fontWeight="extraBold">{title}</Typography>
      <Typography component="p" variant="h4">{subtitle}</Typography>
    </Card>
  );
};

export { BoxWithIcon };
